import { CRow } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarRow = (props) => {
  const { children } = props
  return <CRow {...props}>{children}</CRow>
}

export { ConfiaCarRow }
